'use client';
import React from 'react';

interface StoryItem {
  id: number;
  image: string;
  alt: string;
  text: string;
  reverse?: boolean;
}

const storyItems: StoryItem[] = [
{
  id: 1,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f9539fcb-1765245683976.png",
  alt: 'Team of financial experts and real estate professionals in a strategic planning meeting',
  text: 'At Neo Capital Group, our journey began with a bold idea — to redefine how India invests in land. Founded by visionaries across finance, engineering, and real estate, we have grown into a trusted name that transforms aspirations into tangible, appreciating assets for thousands of investors nationwide.'
},
{
  id: 2,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_14746311f-1774548190493.png",
  alt: 'Premium residential plot development with wide roads and green landscaping',
  text: 'Our philosophy is rooted in the belief that wealth creation begins with smart land ownership. We specialize in premium plot development — creating gated communities, planned layouts, and strategically located developments that offer long-term appreciation and secure investment opportunities for Future Generation and NRI families and HNI investors alike.',
  reverse: true
},
{
  id: 3,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_134902f04-1786115410145.png",
  alt: 'Aerial view of a completed Neo Capital Group plot development project',
  text: 'Every project we undertake is infused with our core ethos — Upscaling Wealth. Transforming New Horizons. Whether it\'s creating innovative real estate communities, designing future-ready plot developments, or facilitating high-value investment opportunities, we always keep our clients\' long-term prosperity at the heart of everything we do.'
}];


export default function OurStorySection() {
  return (
    <section id="our-story" className="py-16 md:py-20">
      {/* Section Header */}
      <div className="container mx-auto px-4 max-w-5xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-dark font-avenir mb-4">
            Our Story
          </h2>
          <hr className="border-0 h-0.5 bg-brand-green w-20 mx-auto" />
        </div>
      </div>

      {/* Story Items */}
      <div className="space-y-0">
        {storyItems.map((item) =>
        <div
          key={item.id}
          className={`flex flex-col ${
          item.reverse ? 'md:flex-row-reverse' : 'md:flex-row'} items-stretch`
          }>
          
            {/* Image */}
            <div className="w-full md:w-1/2 relative overflow-hidden" style={{ minHeight: '300px' }}>
              <img
              src={item.image}
              alt={item.alt}
              className="w-full h-full object-cover absolute inset-0 hover:scale-105 transition-transform duration-700" />
            
            </div>

            {/* Text */}
            <div
            className={`w-full md:w-1/2 flex items-center p-8 md:p-12 lg:p-16 ${
            item.id % 2 === 0 ? 'bg-brand-bg-light' : 'bg-white'}`
            }>
            
              <p className="text-brand-gray font-avenir text-base leading-relaxed">
                {item.text}
              </p>
            </div>
          </div>
        )}
      </div>
    </section>);

}